import { Container } from 'pixi.js';
import Ui from './ui/Ui';
import { GameConfigs } from './lib/globals/GameConfigs';
import { ErrorView } from './view/notifications/ErrorView';

class ErrorPage extends Container {
	constructor() {
		super();
		//ADD ERROR
		this.errorPage = new Ui();
		this.addChild(this.errorPage);
		GameConfigs.errorComponent = this.errorPage;
		this.errorPage.addView(ErrorView);
	}

	resize() {
		if (this.errorPage) {
			this.errorPage.resize(window.CurrentSize.w, window.CurrentSize.h);
		}
	}
}

export default ErrorPage;
